import React, { forwardRef, useImperativeHandle, useState } from "react";
import { cn } from "../../../Utils/helper";
const CommonModal = forwardRef(
  (
    {
      title,
      children,
      actions,
      aboveChildren,
      classNameText,
      classNameModal,
      onOverlayAction,
      canClickOverLay = true,
      showCloseIcon = false,
      closeIcon = null,
      onClose,
      hasError,
      classNameBodyModal = "bg-white",
    },
    ref
  ) => {
    const [isOpen, setIsOpen] = useState(false);

    useImperativeHandle(ref, () => ({
      openModal: () => setIsOpen(true),
      closeModal: () => setIsOpen(false),
    }));

    if (!isOpen) return null;

    const closeModal = () => {
      setIsOpen(false);
      if (onClose) {
        onClose();
      }
    };
    const handleOverlayClick = (e) => {
      if (e.target === e.currentTarget) {
        if (onOverlayAction) {
          onOverlayAction();
          closeModal();
        } else {
          closeModal();
        }
      }
    };
    const handleModalBodyClick = (e) => {
      e.stopPropagation();
    };

    const DefaultCloseIcon = () => (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M18 18L12 12M12 12L6 6M12 12L18 6M12 12L6 18"
          stroke="#A0A0A0"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );

    return (
      <div
        onClick={canClickOverLay ? handleOverlayClick : null}
        className={cn(
          `fixed inset-0 flex items-center justify-center bg-[#ECEEFF] z-50 `,
          classNameModal
        )}
      >
        <div
          onClick={handleModalBodyClick}
          className={cn(
            "relative flex flex-col items-center bg-white rounded-xl p-[30px] max-w-[428px] w-full text-center max-h-[90vh] overflow-y-auto overflow-x-hidden scrollbar-hide",
            classNameBodyModal
          )}
        >
          {/* Close Icon */}
          {showCloseIcon && (
            <button
              onClick={closeModal}
              className="absolute top-2 right-4 p-1 hover:bg-gray-100 rounded-full transition-colors duration-200 z-10"
              aria-label="Close modal"
            >
              {closeIcon ? (
                typeof closeIcon === "string" ? (
                  <img src={closeIcon} alt="Close" className="w-5 h-5" />
                ) : (
                  closeIcon
                )
              ) : (
                <DefaultCloseIcon />
              )}
            </button>
          )}
          {title && <h2 className={`${classNameText} mt-2`}>{title}</h2>}
          <div
            className={
              (title ? "mt-2" : "",
              ` w-full flex flex-col justify-center items-center`)
            }
          >
            {children}
          </div>

          {typeof actions === "function" && (
            <div className="flex gap-3.5 justify-center mt-6 w-full text-sm tracking-tight">
              {actions(() => setIsOpen(false))}
            </div>
          )}
          {aboveChildren && <div className="mt-4 w-full ">{aboveChildren}</div>}
        </div>
      </div>
    );
  }
);

export default CommonModal;
